import React from "react";
import logo from "../../assets/images/burger-menu-icon.svg";

const burgerMenuLogo = props => <img src={logo} alt="burger-menu" />;

export default burgerMenuLogo;
